
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { MapPin } from "lucide-react";
import { GoogleReviewsSection } from './GoogleReviewsSection';
import { ConsultorioServices } from './ConsultorioServices';
import { ConsultorioActions } from './ConsultorioActions';
import { AddressCard } from "@/components/shared/AddressCard";

interface ConsultorioData {
  id: number;
  consultorioId: "paulista" | "mogi" | "suzano";
  name: string;
  address: string;
  city: string;
  cep: string;
  complement: string;
  phone: string;
  googleMapsUrl: string;
  horarios: string[];
  transporte: string[];
  servicos: string[];
  destaces: string[];
}

interface ConsultorioCardProps {
  consultorio: ConsultorioData;
  index: number;
  onCall: (phone: string) => void;
}

export const ConsultorioCard: React.FC<ConsultorioCardProps> = ({
  consultorio,
  index,
  onCall
}) => {
  return (
    <div className="space-y-6 sm:space-y-8">
      {/* Address Card */}
      <AddressCard
        name={consultorio.name}
        address={consultorio.address}
        city={consultorio.city}
        cep={consultorio.cep}
        complement={consultorio.complement}
        phone={consultorio.phone}
        horarios={consultorio.horarios}
        showHours={true}
      />
      
      {/* Services and Reviews Card */}
      <Card className="overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
        <CardContent className="p-0">
          <div className={`grid lg:grid-cols-2 gap-0 ${index % 2 === 1 ? 'lg:grid-cols-2' : ''}`}>
            {/* Image */}
            <div className={`bg-gradient-to-br from-brand-primary/10 to-brand-primary/20 h-64 lg:h-auto flex items-center justify-center ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
              <div className="text-center">
                <div className="w-20 h-20 bg-brand-primary rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <MapPin className="w-10 h-10 text-white" />
                </div>
                <p className="text-gray-600 font-text font-medium">{consultorio.name}</p>
                <p className="text-gray-500 font-text text-sm mt-1">Consultório Moderno</p>
              </div>
            </div>
            
            {/* Content */}
            <div className={`p-6 sm:p-8 ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl sm:text-2xl font-bold font-primary text-gray-800">
                  Serviços & Avaliações
                </h2>
                <div className="bg-brand-primary/10 text-brand-primary px-3 py-1 rounded-full text-sm font-medium">
                  ✓ Verificado
                </div>
              </div>
              
              <ConsultorioServices servicos={consultorio.servicos} destaces={consultorio.destaces} />

              {/* Google Reviews Section */}
              <div className="mb-6 bg-gray-50 rounded-lg p-4">
                <GoogleReviewsSection consultorioId={consultorio.consultorioId} />
              </div>

              <ConsultorioActions 
                consultorio={consultorio}
                onCall={onCall}
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
